


















import {Component, Vue} from 'vue-property-decorator'
import Modal from '@/components/common/Modal.vue'
import {Getter, Mutation, Action} from 'vuex-class'
import {Lead, Location, Room} from '@/store/types'
import FontAwesome from '@/classes/FontAwesome'
import LoaderButton from '@/components/common/LoaderButton.vue'

@Component({
  components: {
    Modal,
    LoaderButton,
  },
})

export default class InventoryCustomRoomOverlay extends Vue {
  @Getter('lead') public lead!: Lead
  @Getter('location') public location!: Location
  @Mutation('setActiveRoomId') public setActiveRoomId!: any
  @Mutation('setInventoryCustomRoomOverlay') public setInventoryCustomRoomOverlay!: any
  @Mutation('setActiveGroups') public setActiveGroups!: any
  @Action('addRoom') public addRoom!: any

  public name = ''
  public loading = false

  public addCustomRoom() {
    if (!this.name.length) {
      return
    }
    this.loading = true
    const data = {
      lead_id: this.lead.id,
      lead_location_id: this.location.id,
      room_id: FontAwesome.ID.CUSTOM,
      name: this.name,
    }
    this.addRoom(data).then((room: Room) => {
      this.setActiveGroups(room.room_id)
      this.setActiveRoomId(room.id)
      this.setInventoryCustomRoomOverlay(false)
      this.loading = false
      this.$router.push({ path: `rooms/${room.id}/items`})
    })
  }
  public cancel() {
    this.setInventoryCustomRoomOverlay(false)
  }
}
